import { useDispatch, useSelector } from 'react-redux';
import { useKeyboard } from '../../../shared/hooks/useKeyboard';
import { useWindowListener } from '../../../shared/hooks/useWindowListener';
import { unsetCreateMode } from '../../wave/thunks/unset-create-mode.thunk';
import { CreateMode } from '../../wave/utils/create.utils';
import { setCreateMode } from '../../wave/thunks/set-create-mode.thunk';
import { pasteWaves } from '../../wave/thunks/paste-waves.thunk';
import { WaveAnnotateSelector } from '../../waves-tags-display-annotate/selectors/wave-tag-display-annotate.selectors';
import { SINGLE_LEAD_STRIP_ID } from '../../plot/components/SingleLeadPlot';
import { noiseTagFilterSelector } from '../../plot/selectors/strip.selectors';

export const useNoiseListener = () => {
  const dispatch = useDispatch();
  const allowInvalidWavesAnnotations = useSelector(WaveAnnotateSelector('INV'));
  const noiseTagFilter = useSelector(
    noiseTagFilterSelector(SINGLE_LEAD_STRIP_ID),
  );
  /*
   * Create listeners
   * Based on the key being pressed, the created wave will have the associated CreateMode type
   */
  useKeyboard('keydown', 'n', () => {
    if (allowInvalidWavesAnnotations && noiseTagFilter) {
      dispatch(
        setCreateMode(CreateMode[noiseTagFilter as keyof typeof CreateMode]),
      );
    }
  });

  useKeyboard('keydown', 'p', () => {
    if (allowInvalidWavesAnnotations) {
      dispatch(setCreateMode(CreateMode.noise));
    }
  });

  useKeyboard('keydown', 'c', () => {
    if (allowInvalidWavesAnnotations) {
      dispatch(setCreateMode(CreateMode.calibration));
    }
  });

  useKeyboard('keydown', 'a', () => {
    if (allowInvalidWavesAnnotations) {
      dispatch(setCreateMode(CreateMode.artifact));
    }
  });

  useKeyboard('keydown', 'i', () => {
    if (allowInvalidWavesAnnotations) {
      dispatch(setCreateMode(CreateMode.p_level_noise));
    }
  });

  useKeyboard('keydown', 'x', () => {
    dispatch(setCreateMode(CreateMode.X));
  });

  useWindowListener('keyup', () => {
    dispatch(unsetCreateMode());
  });

  useKeyboard('keydown', 'v', (event) => {
    if (event.ctrlKey || event.metaKey) {
      dispatch(pasteWaves());
    }
  });
};
